/**
 * The @aircall/ds Button size token shared by every icon-only control in the
 * player action row (view picker, speakers toggle, full screen toggle), so they
 * all render at one identical size next to the 40px playback controls.
 */
export const PLAYER_ACTION_BUTTON_SIZE = "icon-lg";

export enum AUDIO_PLAYER_ERROR {
  RENDER = "AUDIO_RENDERER_ERROR: audio render error",
  DATA_SOURCE = "PIPELINE_ERROR_READ: FFmpegDemuxer: data source error",
}
